module.exports = __webpack_public_path__ + "img/3.bae2ba2.png";